
export class User {
    constructor({
                    //attributes
                    id= null,
                    name= '',
                    lastname= '',
                    email= '',
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null,
                } = {}) {

        //fill attributes
        this.id=id;
        this.name=name;
        this.lastname=lastname;
        this.fullName = (name||'') + " " + (lastname||'')
        this.email=email;
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.deleted_at=deleted_at;
    }

}

export function createUser(data={}) {
    return Object.freeze(new User(data));
}